<div class="row">
    <div class="col-12 mb15" *ngIf="isShowTax">
        <div class="d-flex row">
            <div class="col-auto">
                <div class="af-form-group">
                    <label translate>lblTotalPrice <span translate>lblInclVAT</span></label>
                    <div class="lbl-info">
                        <div class="af-pill bg-blue1 text-bold text-white">
                            {{ workOrderService.totalPriceInclVAT | number:'1.2-2'}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto" *ngIf="isShowTax">
                <div class="af-form-group">
                    <label translate>lblTotalPrice <span translate>lblInclTAX</span></label>
                    <div class="lbl-info">
                        <div class="af-pill bg-blue1 text-bold text-white">
                            {{workOrderService.totalPrice | number:'1.2-2'}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group">
                    <label translate>lblTotalTime</label>
                    <div class="lbl-info">
                        <div class="af-pill bg-blue2 text-bold text-white">
                            <span *ngIf="workOrderService.totalTime"> {{workOrderService.totalTime | number : '1.2-2'}}
                            </span> <span translate>lblhr</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group">
                    <label>
                        <span translate>lblVAT</span>(<span>{{VAT}}</span>%)
                    </label>
                    <div class="lbl-info">
                        <div class="af-pill bg-blue1 text-bold text-white">
                            <span *ngIf="workOrderService.taxDetail">
                                {{workOrderService.taxDetail.vatPrice | number:'1.2-2'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto" *ngIf="isShowTax">
                <div class="af-form-group">
                    <label>
                        <span translate>lblPersonnelTax</span>(<span>{{workOrderService.personnelTax}}</span>%)
                    </label>
                    <div class="lbl-info">
                        <div class="af-pill bg-blue2 text-bold text-white">
                            <span *ngIf="workOrderService.taxDetail">
                                {{workOrderService.taxDetail.personnelTax | number:'1.2-2'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto" *ngIf="isShowTax && isMaterialTaxVisible">
                <div class="af-form-group">
                    <label>
                        <span translate>lblMaterialTax</span>(<span>{{workOrderService.materialTax}}</span>%)
                    </label>
                    <div class="lbl-info">
                        <div class="af-pill bg-blue1 text-bold text-white">
                            <span *ngIf="this.workOrderService.taxDetail">
                                {{workOrderService.taxDetail.materialTax | number:'1.2-2'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 mb15">
        <div class="d-flex align-items-center mb-2">
            <h4 class="title16 text-uppercase" translate>lblDemands</h4>
            <button class="btn btn-primary customize-btn ml-auto" [disabled]="!editAppointmentService.isEdit"
                (click)="AddDemand()" aria-label="Center Align">
                <em class="fa fa-plus mr-2"></em><span translate>lblAddDemand</span></button>
            <button class="btn btn-primary customize-btn ml-2" *ngIf="!hideServiceAsDemand"
                [disabled]="!editAppointmentService.isEdit || workOrderService.isSavingAppointment(editAppointmentService.appointmentDetails.id)"
                (click)="OpenSearchServicesPopUp(0,true)"
                aria-label="Center Align">
                <em class="fa fa-plus mr-2"></em><span translate>lblAddServiceAsDemand</span></button>
            <button class="btn btn-primary customize-btn ml-2"
                [disabled]="!editAppointmentService.isEdit || workOrderService.isSavingAppointment(editAppointmentService.appointmentDetails.id)"
                (click)="OpenSearchPackagePopUp(0,true)" aria-label="Center Align">
                <em class="fa fa-plus mr-2"></em><span translate>lblAddPackageAsDemand</span></button>
            <button class="btn btn-primary customize-btn ml-2" (click)="createNewOrder(splitOrderDemands)"
                aria-label="Center Align" [disabled]="isAppointmentSplitDemandList <= 1">
                <em class="fa fa-minus-circle mr-2"></em><span translate> lblSplitDemands </span></button>
        </div>
        <ng-container *ngIf="!editAppointmentService.isOpenByOtherUser">
            <div *ngIf="!editAppointmentService.isEdit && !isOpenFromPlanning">
                <div class="text-right mb10"><span class="msg" translate>lblDisabledServiceMessage</span></div>
            </div>
        </ng-container>

        <!-- border-bottom tableMx-15 -->
        <div class="table-responsive border">
            <table class="tablest1">
                <thead>
                    <tr>
                        <th style="width: 50px" scope="col" translate>
                            <a *ngIf="appointmentServiceDetail?.appointmentDemandList && appointmentServiceDetail.appointmentDemandList?.length>0"
                                (click)="onSelectAllDemand(!selectAll)" class="btn btn-ico">
                                <em *ngIf="selectAll" class="fas fa-filter fa-lg text-danger"></em>
                                <em *ngIf="!selectAll" class="fas fa-filter fa-lg"></em>
                            </a>
                        </th>
                        <th style="width: 50px" scope="col" translate></th>
                        <th style="width: 50px" scope="col" translate>lblDemand</th>
                        <th style="width: 210px" scope="col" translate>lblShortDescription</th>
                        <th scope="col" translate>lblDemandDescription</th>
                        <th style="width: 50px" scope="col" translate>lblStatus</th>
                        <th scope="col" class="text-center no-nowrap" style="width: 100px" translate>lblCustomerApproval
                        </th>
                        <th scope="col" class="text-center no-nowrap" style="width: 20px" translate>lblCustomerRemarks
                        </th>
                        <th scope="col" class="text-center no-nowrap" style="width: 90px" translate>lblHidePrice</th>
                        <th scope="col" class="text-center no-nowrap" style="width: 90px" translate>lblWarranty</th>
                        <th scope="col" class="no-nowrap" style="width: 140px" translate>lblBillToCustomer
                        </th>

                        <th scope="col" class="text-right no-nowrap" style="width: 80px"><span style="width: 80px"
                                class="d-block" translate>lblSalesPrice</span><span class="text-sm1"
                                translate>lblInclVAT</span></th>
                        <th scope="col" class="text-right no-nowrap" style="width: 80px" translate>
                            lblFixedPrice<br><span class="text-sm1" translate>lblInclVAT</span></th>
                        <th scope="col" class="text-right no-nowrap" style="width: 80px"><span style="width: 80px"
                                class="d-block" translate>lblTotalPrice</span><span class="text-sm1"
                                translate>lblInclVAT</span></th>
                        <th scope="col" class="text-right no-nowrap" style="width: 80px" *ngIf="isShowTax"><span
                                style="width: 80px" class="d-block" translate>lblTotalPrice</span><span class="text-sm1"
                                translate>lblInclTAX</span></th>
                        <th scope="col" style="width: 75px" class="text-center">
                            <span class="mr-1" translate>lblAction</span><br>
                            <a *ngIf="selectAll" (click)="deleteDemand(true)" class="btn btn-ico del-icon"
                                ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" container="body">
                                <em class="far fa-trash-alt fa-lg"></em>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngIf="appointmentServiceDetail?.appointmentDemandList && appointmentServiceDetail.appointmentDemandList?.length>0; else load_else">
                        <ng-container
                            *ngFor="let demand of appointmentServiceDetail.appointmentDemandList; let i=index">
                            <tr
                                [ngClass]="{'bgColor' :demand.isAdditionallyAdded , 'bg-highlight-d': 0 === demand.demandNo % 2}">
                                <td>
                                    <a (click)="onDemandFilterSelect(demand.demandNo)" class="btn btn-ico"
                                        ngbTooltip="{{ 'lblFilter' | translate}}">
                                        <em *ngIf="demand.isFilterSelected"
                                            class="fas fa-filter fa-lg text-danger"></em>
                                        <em *ngIf="!demand.isFilterSelected" class="fas fa-filter fa-lg"></em>
                                    </a>
                                </td>
                                <td>
                                    <em ngbTooltip="{{ 'lblNotSynced' | translate}}"
                                        *ngIf=" isDMSEnable && demand.dmsJobLineNo === ''"
                                        class="fas fa-exclamation-triangle fa-lg text-danger"></em>
                                </td>
                                <td>
                                    {{ demand.demandNo }}
                                </td>
                                <td>
                                    <input required type="text" class="form-control customize-textbox"
                                        [value]="demand.shortDescription"
                                        [disabled]="!editAppointmentService.isEdit || disableShortDescriptionOnFilter  "
                                        placeholder="{{ 'lblShortDescription' | translate }}"
                                        [(ngModel)]="demand.shortDescription" (ngModelChange)="emitServiceData()"
                                        (blur)="onBlurShortDescription(i)" (keyup.enter)="onBlurShortDescription(i)"
                                        maxlength="50" />
                                </td>
                                <td>
                                    <textarea autocomplete="off" class="form-control customize-textbox "
                                        appTextareaAutoresize [value]="demand.customerRequirement"
                                        [disabled]="!editAppointmentService.isEdit "
                                        placeholder="{{ 'lblDemandDescription' | translate }}"
                                        [(ngModel)]="demand.customerRequirement" (ngModelChange)="emitServiceData()">
                                        </textarea>
                                </td>
                                <td>
                                    <button [ngbTooltip]="demand.demandStatus" [placement]="tooltipPlacement"
                                        tooltipClass="custom-revert" (click)="openUpdateJob(mymodal,demand)"
                                        *ngIf="demand.demandStatus == 'Pending'" placement="bottom"
                                        aria-label="Center Align" [disabled]="!editAppointmentService.isEdit">
                                        <img src="./../../../assets/images/ic_pending.png" height="32" width="32"
                                            class="text-success" alt="" />
                                    </button>
                                    <button [ngbTooltip]="demand.demandStatus" [placement]="tooltipPlacement"
                                        tooltipClass="custom-revert" (click)="openUpdateJob(mymodal,demand)"
                                        *ngIf="demand.demandStatus == 'In Progress'" placement="bottom"
                                        aria-label="Center Align" [disabled]="!editAppointmentService.isEdit">
                                        <img src="./../../../assets/images/ic_inProgress.png" height="32" width="32"
                                            class="text-success" alt="" />
                                    </button>
                                    <button [ngbTooltip]="demand.demandStatus" [placement]="tooltipPlacement"
                                        tooltipClass="custom-revert" (click)="openUpdateJob(mymodal,demand)"
                                        *ngIf="demand.demandStatus == 'Completed'" placement="bottom"
                                        aria-label="Center Align" [disabled]="!editAppointmentService.isEdit">
                                        <img src="./../../../assets/images/Complete.png" height="32" width="32"
                                            class="text-success" alt="" />
                                    </button>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center align-items-center">

                                        <ng-container
                                            *ngIf="demand.sentForCustomerApproval && demand.customerReply==='Approved'">
                                            <!-- Approved -->
                                            <em class="fas fa-check"></em>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="demand.sentForCustomerApproval && demand.customerReply==='Rejected'">
                                            <!-- Rejected -->
                                            <em class="fas fa-times"></em>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="!demand.sentForCustomerApproval && (demand.customerReply==='' || demand.customerReply===null)">
                                            <!-- No need of cust approval -->
                                            <span class="form-check p-0">
                                                <input type="checkbox" [disabled]="!editAppointmentService.isEdit "
                                                    id="DemandCustomerApproval{{demand.id}}"
                                                    [(ngModel)]="demand.sentForCustomerApproval"
                                                    (ngModelChange)="emitServiceData()" (change)="checkValue(demand)" />
                                            </span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="demand.sentForCustomerApproval && demand.customerReply==='Pending'">
                                            <!-- sent for approval -->
                                            <span class="form-check p-0">
                                                <input type="checkbox" [disabled]="!editAppointmentService.isEdit "
                                                    id="DemandCustomerApproval{{demand.id}}"
                                                    [(ngModel)]="demand.sentForCustomerApproval"
                                                    (ngModelChange)="emitServiceData()" class="vm mr-2"
                                                    (change)="checkValue(demand)" />
                                            </span>
                                            <span class="ico-div" style="height: 20px;"></span>
                                            <a class="btn btn-ico">
                                                <em class="fas fa-user-clock font16"></em>
                                            </a>
                                        </ng-container>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <a class="btn btn-ico" *ngIf="demand.customerApprovalComment"
                                        ngbTooltip="{{ 'lblApprovalComment' | translate }}" tooltipClass="custom-revert"
                                        (click)="ViewComment(demand.customerApprovalComment)">
                                        <em class="fas fa-eye fa-lg"></em>
                                    </a>
                                </td>

                                <td class="text-center">
                                    <div class="form-check p-0">
                                        <input type="checkbox" id="HidePrice{{demand.id}}"
                                            [(ngModel)]="demand.isHidePrice"
                                            [disabled]="!editAppointmentService.isEdit "
                                            (ngModelChange)="emitServiceData()" />
                                    </div>
                                </td>
                                <td class="text-center">
                                    <div class="form-check p-0">
                                        <input type="checkbox" id="Demand{{demand.id}}"
                                            [(ngModel)]="demand.isInWarranty"
                                            [disabled]="!editAppointmentService.isEdit "
                                            (click)="onInWarrantyChange($event, i)"
                                            (ngModelChange)="emitServiceData()" />
                                    </div>
                                </td>
                                <td class="text-center" style="display: flex;">
                                    <div class='lbl-info' style="width: 140px;">
                                        <ng-select appendTo="body" [clearable]="false" [searchable]="false"
                                            [ngModelOptions]="{standalone: true}" [(ngModel)]="demand.billToCustomer"
                                            [attr.title]="demand.billToCustomerName || ''"
                                            [disabled]=" !editAppointmentService.isEdit || editAppointmentService.appointmentDetails.isFromArchive">
                                            <ng-option *ngFor="let item of customerList" [value]="item.customerNo">
                                                {{item.customerNo}}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <button type="button" class="btn" (click)="OpenCustomerValidation(i,true)"
                                        aria-label="Center Align">
                                        <em class="fa fa-search" aria-hidden="true"></em>
                                    </button>
                                </td>

                                <td class="text-right">{{demand.sumPerServiceWithoutDiscountInclVAT| number:'1.2-2'}}
                                </td>
                                <td class="text-right">
                                    <input type="text" style="width: 80px"
                                        class="form-control customize-textbox text-right"
                                        [value]="demand.fixedPrice | number:'1.2-2'"
                                        [disabled]="!editAppointmentService.isEdit " (keypress)="checkDiscount($event)"
                                        (blur)="onBlur($event,i,'Demands')"
                                        [ngModel]="demand.fixedPrice | number:'1.2-2'"
                                        (ngModelChange)="emitServiceData()" />
                                </td>

                                <td class="text-right">{{demand.totalPriceInclVAT| number:'1.2-2'}}</td>
                                <td class="text-right" *ngIf="isShowTax">{{demand.sumPerServiceInclTax |
                                    number:'1.2-2'}}</td>
                                <td class="nowrap text-center">
                                    <span class="ico-div"
                                        *ngIf="editAppointmentService.isEdit && !editAppointmentService.appointmentDetails.isFromArchive; else disabledUpload">
                                        <a class="btn btn-ico" placement="bottom" (click)="OpenModel(demand)"
                                            *ngIf="allowCustomerToUploadDoc && userRoleRightsDetails?.canAdd">
                                            <em class="fa fa-upload fa-lg"
                                                ngbTooltip="{{'lblUploadDocument' | translate}}"
                                                tooltipClass="custom-revert"></em>
                                        </a>
                                    </span>
                                    <ng-template #disabledUpload>
                                        <span class="ico-div"
                                            *ngIf="allowCustomerToUploadDoc && userRoleRightsDetails?.canAdd">
                                            <a class="btn btn-ico disabled"
                                                ngbTooltip="{{'lblUploadDocument' | translate}}"
                                                tooltipClass="custom-revert" container="body" placement="bottom">
                                                <em class="fa fa-upload fa-lg text-muted"></em>
                                            </a>
                                        </span>
                                    </ng-template>
                                    <span class="ico-div"
                                        *ngIf="editAppointmentService.isEdit && !editAppointmentService.appointmentDetails.isFromArchive; else disabledViewDocument">
                                        <a class="btn btn-ico mr-1" (click)="ViewDocument(demand)"
                                            *ngIf="allowCustomerToUploadDoc && userRoleRightsDetails?.canView">
                                            <em class="fas fa-eye fa-lg" ngbTooltip="{{'lblViewDocument' | translate}}"
                                                tooltipClass="custom-revert"></em>
                                            <span id="viewdoc"
                                                class="position-absolute translate-middle badge rounded-pill count">
                                                {{GetDemandDocCount(demand)}} </span>
                                        </a>
                                    </span>
                                    <ng-template #disabledViewDocument>
                                        <span class="ico-div"
                                            *ngIf="allowCustomerToUploadDoc && userRoleRightsDetails?.canAdd">
                                            <a class="btn btn-ico disabled mr-1"
                                                ngbTooltip="{{'lblViewDocument' | translate}}"
                                                tooltipClass="custom-revert" container="body">
                                                <em class="fas fa-eye fa-lg text-muted"></em>
                                            </a>
                                        </span>
                                    </ng-template>
                                    <span
                                        *ngIf="editAppointmentService.isEdit && !editAppointmentService.appointmentDetails.isFromArchive; else disabledDelete">
                                        <a (click)="deleteDemand(false,i)" class="btn btn-ico del-icon"
                                            ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                            container="body">
                                            <em class="far fa-trash-alt fa-lg"></em>
                                        </a>
                                    </span>
                                    <ng-template #disabledDelete>
                                        <a class="btn btn-ico disabled" ngbTooltip="{{'lblDelete' | translate}}"
                                            tooltipClass="custom-revert" container="body">
                                            <em class="far fa-trash-alt fa-lg text-muted"></em>
                                        </a>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="row mt-3">
    <div class="col-12 mb15">
        <div class="d-flex align-items-center mb-2">
            <h4 class="title16 text-uppercase" translate>lblJob</h4>
        </div>
        <div class="table-responsive border">
            <table class="tablest1">
                <thead>
                    <tr>
                        <th scope="col" style="width: 5%" translate>lblFilter</th>
                        <th scope="col" style="width: 5%" translate>lblDemand</th>
                        <th scope="col" style="width: 5%" translate>lblJob</th>
                        <th scope="col" style="width: 12%" translate>lblPackageNumber</th>
                        <th scope="col" translate>lblDescription</th>
                        <th scope="col" translate></th>
                        <th scope="col" class="text-right" style="width: 150px"><span
                                translate>lblTotalTime</span><br><span class="text-sm1" translate>lblHrs</span></th>
                        <th scope="col" class="text-right" translate style="width: 150px"><span
                                translate>lblSalesPrice</span><br><span class="text-sm1" translate>lblExclVat</span>
                        </th>
                        <th scope="col" class="text-right" translate style="width: 150px"><span
                                translate>lblSalesPrice</span><br><span class="text-sm1" translate>lblInclVAT</span>
                        </th>

                        <th scope="col" class="text-right" translate style="width: 150px"><span
                                translate>lblTotalPrice</span><br><span class="text-sm1" translate>lblInclVAT</span>
                        </th>
                        <th scope="col" style="width: 150px" class="text-center" translate>lblAction</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngIf="appointmentServiceDetail?.appointmentJobList && appointmentServiceDetail?.appointmentJobList?.length>0; else load_else">
                        <ng-container *ngFor="let job of appointmentServiceDetail.appointmentJobList; let i=index">
                            <tr
                                [ngClass]="{'bgColor' :job.isAdditionallyAdded , 'bg-highlight-d': 0 === job.demandNo % 2}">
                                <td>
                                    <a (click)="onJobFilterSelect(job.jobId)" class="btn btn-ico">
                                        <em *ngIf="job.isFilterSelected" class="fas fa-filter fa-lg text-danger"></em>
                                        <em *ngIf="!job.isFilterSelected" class="fas fa-filter fa-lg"></em>
                                    </a>
                                </td>
                                <td>{{ job.demandNo }}</td>
                                <td>{{job.jobId}}</td>
                                <td>
                                    <div><span *ngIf="job.afxPackageNo"><span *ngIf="!isDMSEnable"><button
                                                    class="btn btn-ico mb-1" (click)="DeletePackage(i)"
                                                    [disabled]="!editAppointmentService.isEdit " translate>
                                                    <em class="fas fa-times fa-lg"
                                                        ngbTooltip="{{'lblDelete' | translate}}"
                                                        tooltipClass="custom-revert"></em>
                                                </button></span>{{job.afxPackageNo}} -
                                            {{job.afxPackageVersionNo}}</span>
                                    </div>
                                </td>
                                <td>{{job.description}}</td>
                                <td>
                                    <span *ngIf="job.warningLightLogo?.length>0">
                                        <em class="fa fa-exclamation-triangle fa-lg" [ngbTooltip]="tipContent"
                                            tooltipClass="custom-revert long-tooltop"></em>
                                        <ng-template #tipContent>
                                            <div style="max-width: 350px;">
                                                <h3 translate class="pb-2">lblWarningLight</h3>
                                                <img *ngFor="let icon of job.warningLightLogo" af-image
                                                    [data-code]="icon.image" [ngbTooltip]="icon.image"
                                                    class="{{icon.image}}-icon common"
                                                    style="margin-right:3px;width: 33px;height:28px;" class="brandicon"
                                                    alt="img not found" />
                                            </div>
                                        </ng-template>
                                    </span>
                                </td>
                                <td class="text-right">{{job.totalTime | number:'1.2-2'}}</td>
                                <td class="text-right">{{job.sumPerServiceExcludeTax| number:'1.2-2'}}</td>
                                <td class="text-right">{{job.salesPriceWithoutDiscountInclVAT| number:'1.2-2'}}</td>
                                <td class="text-right">{{job.price| number:'1.2-2'}}</td>

                                <td class="nowrap text-left">
                                    <button class="btn btn-ico" *ngIf="!hideServiceAsDemand"
                                        (click)="OpenSearchServicesPopUp(i,false)"
                                        [disabled]="!editAppointmentService.isEdit " translate>
                                        <em class="fas fa-plus fa-lg" ngbTooltip="{{'lblService' | translate}}"
                                            tooltipClass="custom-revert"></em>
                                    </button>
                                    <span class="ico-div" [hidden]="hideServiceAsDemand"></span>
                                    <button class="btn btn-ico" (click)="OpenSearchLaborPopUp(i)"
                                        [disabled]="!editAppointmentService.isEdit " translate>
                                        <em class="fa fa-cogs fa-lg" ngbTooltip="{{'lblLabors' | translate}}"
                                            tooltipClass="custom-revert"></em>
                                    </button>
                                    <span class="ico-div" *ngIf="isIntegrationWithParts"></span>
                                    <button class="btn btn-ico" *ngIf="isIntegrationWithParts"
                                        (click)="OpenSearchPartsPopUp(i)" [disabled]="!editAppointmentService.isEdit ">
                                        <em class="fas fa-tools fa-lg" ngbTooltip="{{'lblParts' | translate}}"
                                            tooltipClass="custom-revert"></em>
                                    </button>
                                    <span class="ico-div"></span>
                                    <button class="btn btn-ico" (click)="OpenSearchPackagePopUp(i,false)"
                                        ngbTooltip="{{'lblPackage' | translate}}" tooltipClass="custom-revert"
                                        [disabled]="!editAppointmentService.isEdit || job.afxPackageNo ">
                                        <em class="fas fa-box-open fa-lg"></em>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="11" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="row mt-3">
    <div class="col-12 mb15">
        <div class="d-flex align-items-center mb-2">
            <h4 class="title16 text-uppercase" translate>lblJobDetail</h4><button class="btn btn-primary ml-auto"
                [disabled]="!editAppointmentService.isEdit " (click)="onRefreshStock()" translate><em
                    class="fas mr-2 fa-sync"></em>lblRefreshStock</button>
        </div>
        <div class="table-responsive border">
            <table class="tablest1">
                <thead>
                    <tr>
                        <th scope="col" translate></th>
                        <!-- <th scope="col" translate></th> -->
                        <th scope="col" translate>lblD/J</th>
                        <th scope="col" translate>lblCostType</th>
                        <th scope="col" translate>lblMakeCode</th>
                        <th scope="col" style="width: 7%" translate>lblNumber</th>
                        <th scope="col" style="width: 17%" translate>lblDescription</th>
                        <th *ngIf="isMechanicLineAssignmentEnabled" scope="col" style="width:75px">
                            <span translate>lblNoOf</span><br>
                            <span translate>lblResources</span>
                        </th>
                        <th scope="col" translate class="text-right part-stock-col">
                            <div class="form-row">
                                <div class="col-12 text-center" translate>
                                    lblPartInStock
                                </div>
                                <div class=" text-center" [ngClass]="CentralPart ? 'col-3' : 'col-4'" translate>
                                    lblLocal
                                </div>
                                <div class="text-center border-left-black" [ngClass]="CentralPart ? 'col-3' : 'col-4'"
                                    translate>
                                    lblOH
                                </div>
                                <div class="text-center border-left-black" [ngClass]="CentralPart ? 'col-3' : 'col-4'"
                                    translate>
                                    lblStatus
                                </div>
                                <div *ngIf="CentralPart" class="col-4  text-center border-left-black" translate>
                                    lblCentral
                                </div>
                            </div>
                        </th>
                        <th scope="col" style="width: 80px" class="no-nowrap text-right"><span
                                translate>lblQtyShort</span>/<span translate>lblTime</span><br><span class="text-sm1"
                                translate></span></th>
                        <th scope="col" class="text-right " style="width: 100px"><span
                                translate>lblUnitPrice</span><br><span class="text-sm1" translate>lblExclVat</span></th>
                        <th scope="col" class="text-right " style="width: 100px"><span
                                translate>lblUnitCost</span><br><span class="text-sm1" translate>lblExclVat</span></th>
                        <th scope="col" class="text-right" style="width: 80px"><span
                                translate>lblFixedPrice</span><br><span class="text-sm1" translate>lblExclVat</span>
                        </th>

                        <!-- sales Price -->
                        <th scope="col" class="text-right no-nowrap" style="width: 130px"><span
                                translate>lblSalesPrice</span><br><span class="text-sm1" translate>lblExclVat</span>
                        </th>
                        <th scope="col" class="text-right no-nowrap" style="width: 130px"><span
                                translate>lblSalesPrice</span><br><span class="text-sm1" translate>lblInclVAT</span>
                        </th>

                        <!-- discount -->
                        <th scope="col" class="text-right no-nowrap" style="width: 80px"><span style="width: 100px"
                                translate>lblDiscount <span>(%)</span></span>

                            <div class=" d-flex ">
                                <span class=" pl-0 text-theme flex-grow-1 font11" translate>lblPersonnel</span>
                                <div class=" pr-0">
                                    <input type="text" class="form-control textDiscount customize-textbox  text-right"
                                        [value]="personelDiscount | number:'1.2-2'" maxlength="5"
                                        [ngModel]="personelDiscount | number:'1.2-2'"
                                        (blur)="onBlurPersonnelDiscount($event)" (keypress)="checkDiscount($event)" />
                                </div>
                            </div>

                            <div class="d-flex">
                                <span class="flex-grow-1 pl-0 text-theme font11" translate>lblMaterial</span>
                                <div class=" pr-0">
                                    <input type="text" class="form-control textDiscount customize-textbox text-right"
                                        [value]="materialDiscount | number:'1.2-2'" maxlength="5"
                                        [ngModel]="materialDiscount | number:'1.2-2'"
                                        (blur)="onBlurMaterialDiscount($event)" (keypress)="checkDiscount($event)" />
                                </div>
                            </div>
                        </th>

                        <!-- Total price -->
                        <th scope="col" class="text-right no-nowrap" style="width: 130px" translate><span
                                translate>lblTotalPrice</span><br><span class="text-sm1" translate>lblExclVat</span>
                        </th>
                        <th scope="col" class="text-right no-nowrap" style="width: 130px" translate><span
                                translate>lblTotalPrice</span><br><span class="text-sm1" translate>lblInclVAT</span>
                        </th>


                        <th scope="col" style="width: 75px" class="text-center" translate>lblAction</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngIf="appointmentServiceDetail?.appointmentJobDetailList && appointmentServiceDetail?.appointmentJobDetailList?.length>0; else load_else">
                        <ng-container
                            *ngFor="let jobdetail of appointmentServiceDetail.appointmentJobDetailList; let i=index">
                            <tr
                                [ngClass]="{'bgColor' :jobdetail.isAdditionallyAdded, 'bg-highlight-d': 0 === jobdetail.demandNo % 2} ">
                                <td><em ngbTooltip="{{ 'lblNotSynced' | translate}}"
                                        *ngIf=" isDMSEnable && jobdetail.dmsLineNo === ''"
                                        class="fas fa-exclamation-triangle fa-lg text-danger"></em>
                                </td>
                                <!-- <td>
                                    <button (click)="changeJobDetailToPrevious(jobdetail)">
                                        <em class="fas fa-caret-up" style="font-size: 20px;"></em>
                                    </button>
                                    <button (click)="changeJobDetailToNext(jobdetail)">
                                        <em class="fas fa-caret-down" style="font-size: 20px;"></em>
                                    </button>
                                </td> -->
                                <td>{{ jobdetail.demandNo }}/{{ jobdetail.jobDetailsId }}</td>
                                <td *ngIf="jobdetail.costType" translate>lbl{{jobdetail.costType}}</td>
                                <td *ngIf="!jobdetail.costType">{{jobdetail.costType}}</td>
                                <td>{{jobdetail.makeCode}}</td>
                                <td>{{jobdetail.salesPart}}</td>
                                <td>
                                    <textarea class="form-control customize-textbox " [value]="jobdetail.description"
                                        [disabled]="!editAppointmentService.isEdit "
                                        placeholder="{{'lblDescription' | translate}}"
                                        [(ngModel)]="jobdetail.description" (ngModelChange)="emitServiceData()">
                                        </textarea>
                                </td>
                                <td *ngIf="isMechanicLineAssignmentEnabled" class="nowrap">
                                    <ng-container
                                        *ngIf="jobdetail.costType === 'Personnel' || jobdetail.costType === 'Material' || jobdetail.costType === 'ExtService'; else noResourceCell">
                                        <span class="mr-1">{{ getResourceCount(jobdetail.id) }}</span>
                                        <button class="btn btn-sm px-1 py-0"
                                            [ngClass]="isResourceAssignmentBlockedByDms(jobdetail) ? 'btn-outline-danger disabled' : 'btn-outline-secondary'"
                                            [style.cursor]="isResourceAssignmentBlockedByDms(jobdetail) ? 'not-allowed' : 'pointer'"
                                            (click)="openResourceAssignment(jobdetail)"
                                            [ngbTooltip]="isResourceAssignmentBlockedByDms(jobdetail) ? ('lblLineNotSyncedToDms' | translate) : ('lblAssignMechanic' | translate)"
                                            tooltipClass="custom-revert" container="body">
                                            [...]
                                        </button>
                                        <span *ngIf="jobdetail.primaryEmployeeNo"
                                            class="ml-1 font-weight-bold text-primary small">
                                            {{ jobdetail.primaryEmployeeNo }}
                                        </span>
                                    </ng-container>
                                    <ng-template #noResourceCell>—</ng-template>
                                </td>
                                <td class="part-stock-col">
                                    <div class="form-row" *ngIf="jobdetail.costType == 'Material'">
                                        <div class="text-center " [ngClass]="CentralPart ? 'col-3' : 'col-4'">
                                            <ng-container *ngIf="isRomnasEnabled;else romnasdisabled ">
                                                {{jobdetail.partTotalQtyOnLocal >0 ? (jobdetail.partTotalQtyOnLocal |
                                                number:'1.2-2'): '-'}}
                                            </ng-container>
                                            <ng-template #romnasdisabled>
                                                {{jobdetail.partTotalQtyOnLocal | number:'1.2-2'}}
                                            </ng-template>
                                        </div>
                                        <div class="text-center border-left-black"
                                            [ngClass]="CentralPart ? 'col-3' : 'col-4'">
                                            {{jobdetail.partAvailableQtyOnHand | number:'1.2-2'}}
                                        </div>
                                        <div class="text-center border-left-black"
                                            [ngClass]="CentralPart ? 'col-3' : 'col-4'"
                                            [title]="jobdetail?.itemStatusName ?? ''">
                                            <img *ngIf="showItemStatusIcon; else noImage;" af-item-status-icon
                                                [data-code]="jobdetail?.itemStatusId" data-type="ITEM_STATUS"
                                                class="brandicon common" alt="img" />
                                            <ng-template #noImage>
                                                <img af-item-status-icon [data-code]="0" data-type="ITEM_STATUS"
                                                    class="brandicon common" alt="img" />
                                            </ng-template>
                                        </div>
                                        <div class="col-3  text-center border-left-black" *ngIf="CentralPart">
                                            <div class="color-box shd" style="background-color:#009900"
                                                *ngIf="isRomnasEnabled &&(jobdetail.partAvailableQtyOnCentral==1 || jobdetail.partAvailableQtyOnCentral==3);else romnasdisabledctrl">
                                            </div>
                                            <ng-template #romnasdisabledctrl>
                                                <div *ngIf="!isRomnasEnabled else showdash">
                                                    {{jobdetail.partAvailableQtyOnCentral | number:'1.2-2'}}
                                                </div>
                                                <ng-template #showdash>
                                                    <!-- {{jobdetail.partAvailableQtyOnCentral >0 ? (jobdetail.partAvailableQtyOnCentral | number:'1.2-2'): '-'}} -->
                                                    <div class="color-box shd" style="background-color:#FF1D17"
                                                        *ngIf="isRomnasEnabled &&jobdetail.partAvailableQtyOnCentral==2;">
                                                    </div>
                                                </ng-template>
                                            </ng-template>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <input type="text" class="form-control customize-textbox text-right"
                                        [value]="jobdetail.plannedQuantity  | number:'1.2-2'"
                                        placeholder="{{jobdetail.costType==='Material'? totalQuantity : totalTime}}"
                                        [ngModel]="jobdetail.plannedQuantity  | number:'1.2-2'"
                                        [disabled]="!editAppointmentService.isEdit "
                                        (keypress)="isQtyPrice($event,jobdetail.plannedQuantity)"
                                        (ngModelChange)="checkJobQty($event,i);emitServiceData()"
                                        (blur)="onBlurQuntity($event,i)" />
                                </td>
                                <td>
                                    <input type="text" class="form-control mb-2 text-right"
                                        [ngModel]="jobdetail.unitPrice | stringToNumber | number:'1.2-2'"
                                        pattern="^[\d,.\s]+$" placeholder="Enter Price" maxlength="10" id="price"
                                        (blur)="onBlurUnitPrice($event,i)">
                                </td>
                                <td class="text-right">
                                    {{jobdetail.costPrice | number:'1.2-2'}}
                                </td>
                                <td class="text-right">
                                    {{jobdetail.fixedPrice | number:'1.2-2'}}
                                </td>

                                <!-- sales price -->
                                <td class="text-right">{{jobdetail.salesPriceWithoutDiscount | number:'1.2-2'}}</td>
                                <td class="text-right">{{jobdetail.salesPriceWithoutDiscountInclVAT | number:'1.2-2'}}
                                </td>

                                <!-- discount -->
                                <td class="text-right">
                                    <input type="text" class="form-control customize-textbox text-right"
                                        [value]="jobdetail.discount | number:'1.2-2'" style="max-width: inherit;"
                                        [ngModel]="jobdetail.discount | number:'1.2-2'" maxlength="5"
                                        (blur)="onBlurDiscount($event,i)" (keypress)="checkDiscount($event)"
                                        (ngModelChange)="emitServiceData()"
                                        [disabled]="!editAppointmentService.isEdit" />
                                </td>

                                <!-- Total Price -->
                                <td class="text-right">{{jobdetail.salesPriceAmount | number:'1.2-2'}}</td>
                                <td class="text-right">{{jobdetail.salesPriceAmountVAT | number:'1.2-2'}}</td>


                                <td class="nowrap text-right">
                                    <span *ngIf="jobdetail.costType == 'Material'">
                                        <span
                                            *ngIf="editAppointmentService.isEdit && !editAppointmentService.appointmentDetails.isFromArchive; else disabledJobDetailAlter">
                                            <a (click)="getAlternatePart(i)"
                                                [disabled]="!editAppointmentService.isEdit "
                                                class="btn btn-ico del-icon" ngbTooltip="Alternate Part"
                                                tooltipClass="custom-revert" container="body">
                                                <em class="icon-alternate font20"></em>
                                            </a>
                                        </span>
                                        <ng-template #disabledJobDetailAlter>
                                            <a class="btn btn-ico disabled" ngbTooltip="Alternate Part"
                                                tooltipClass="custom-revert" container="body">
                                                <em class="icon-alternate font20 text-muted"></em>
                                            </a>
                                        </ng-template>
                                    </span>

                                    <span *ngIf="!isRomnasEnabled && jobdetail.costType == 'Material'">
                                        <span *ngIf="editAppointmentService.isEdit; else disabledJobDetailReplace">
                                            <a (click)="getReplacementPart(i)"
                                                [disabled]="!editAppointmentService.isEdit "
                                                class="btn btn-ico del-icon" ngbTooltip="Replacement Part"
                                                tooltipClass="custom-revert" container="body">
                                                <em class="icon-replace fa-lg"></em>
                                            </a>
                                        </span>
                                        <ng-template #disabledJobDetailReplace>
                                            <a class="btn btn-ico disabled" ngbTooltip="Replacement Part"
                                                tooltipClass="custom-revert" container="body">
                                                <em class="icon-replace font20 text-muted"></em>
                                            </a>
                                        </ng-template>
                                    </span>
                                    <span
                                        *ngIf="editAppointmentService.isEdit && !editAppointmentService.appointmentDetails.isFromArchive; else disabledJobDetailDelete">
                                        <a (click)="deleteJobDetail(i,jobdetail.id)"
                                            [disabled]="!editAppointmentService.isEdit " class="btn btn-ico del-icon"
                                            ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                            container="body">
                                            <em class="far fa-trash-alt fa-lg"></em>
                                        </a>
                                    </span>
                                    <ng-template #disabledJobDetailDelete>
                                        <a class="btn btn-ico disabled" ngbTooltip="{{'lblDelete' | translate}}"
                                            tooltipClass="custom-revert" container="body">
                                            <em class="far fa-trash-alt fa-lg text-muted"></em>
                                        </a>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>

                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblUpdateJobStatus</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-check">
                    <input mdbRadio class="form-check-input" type="radio" name="JobRadioButton" value="1"
                        [checked]="jobShowStatus == 'Pending'" (change)="ChangeJobStatusValue($event)">
                    <label class="form-check-label" translate> lblPending </label>
                </div>
            </div>
            <div class="col-6">
                <div class="form-check">
                    <input mdbRadio class="form-check-input" type="radio" name="JobRadioButton" value="2"
                        [checked]="jobShowStatus == 'In Progress'" (change)="ChangeJobStatusValue($event)" />
                    <label class="form-check-label" translate> lblInProgress </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-check">
                    <input mdbRadio class="form-check-input" type="radio" name="JobRadioButton" value="3"
                        [checked]="jobShowStatus == 'Completed'" (change)="ChangeJobStatusValue($event)" />
                    <label class="form-check-label" translate> lblCompleted </label>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="updateDemandStatus()"
                [disabled]="updatedJobValue">lblUpdate</button>
            <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>
<ng-template #splitOrderDemands let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblSplitDemands</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="table-responsive border">
            <table class="tablest1">
                <thead>
                    <tr>
                        <th style="width: 50px" scope="col" class="text-center" translate>
                            lblSelect
                            <div class="form-check p-0 mt-2"
                                *ngIf="appointmentSplitDemandList && appointmentSplitDemandList?.length>0;">
                                <input type="checkbox" [(ngModel)]="isAllSelectedForSplit"
                                    (change)="splitDemandsSelection()" />
                            </div>
                        </th>
                        <th style="width: 50px" scope="col" translate></th>
                        <th style="width: 50px" scope="col" translate>lblDemand</th>
                        <th style="width: 210px" scope="col" translate>lblShortDescription</th>
                        <th scope="col" translate>lblDemandDescription</th>
                        <th style="width: 50px" scope="col" translate>lblStatus</th>
                        <th scope="col" class="text-center no-nowrap" style="width: 20px" translate>lblCustomerRemarks
                        </th>
                        <th scope="col" class="text-center no-nowrap" style="width: 90px" translate>lblWarranty</th>
                        <th scope="col" class="no-nowrap" style="width: 140px" translate>lblBillToCustomer
                        </th>

                        <th scope="col" class="text-right no-nowrap" style="width: 80px"><span style="width: 80px"
                                class="d-block" translate>lblSalesPrice</span><span class="text-sm1"
                                translate>lblInclVAT</span></th>
                        <th scope="col" class="text-right no-nowrap" style="width: 80px" translate>
                            lblFixedPrice<br><span class="text-sm1" translate>lblInclVAT</span></th>
                        <th scope="col" class="text-right no-nowrap" style="width: 80px"><span style="width: 80px"
                                class="d-block" translate>lblTotalPrice</span><span class="text-sm1"
                                translate>lblInclVAT</span></th>
                        <th scope="col" class="text-right no-nowrap" style="width: 80px" *ngIf="isShowTax"><span
                                style="width: 80px" class="d-block" translate>lblTotalPrice</span><span class="text-sm1"
                                translate>lblInclTAX</span></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngIf="appointmentSplitDemandList && appointmentSplitDemandList?.length>0; else load_else">
                        <ng-container *ngFor="let demand of appointmentSplitDemandList; let i=index">
                            <tr
                                [ngClass]="{'bgColor' :demand.isAdditionallyAdded , 'bg-highlight-d': 0 === demand.demandNo % 2}">
                                <td class="text-center">
                                    <div class="form-check p-0">
                                        <input type="checkbox" [(ngModel)]="demand.isSelected"
                                            (change)="demandSelectionChanged()" />
                                    </div>
                                </td>
                                <td>
                                    <em ngbTooltip="{{ 'lblNotSynced' | translate}}"
                                        *ngIf=" isDMSEnable && demand.dmsJobLineNo === ''"
                                        class="fas fa-exclamation-triangle fa-lg text-danger"></em>
                                </td>
                                <td>
                                    {{ demand.demandNo }}
                                </td>
                                <td>
                                    {{ demand.shortDescription }}
                                </td>
                                <td>
                                    {{ demand.customerRequirement }}
                                </td>
                                <td>
                                    <button [ngbTooltip]="demand.demandStatus" [placement]="tooltipPlacementForModal"
                                        tooltipClass="custom-revert" *ngIf="demand.demandStatus == 'Pending'"
                                        placement="bottom" aria-label="Center Align" disabled>
                                        <img src="./../../../assets/images/ic_pending.png" height="32" width="32"
                                            class="text-success" alt="" />
                                    </button>
                                    <button [ngbTooltip]="demand.demandStatus" [placement]="tooltipPlacementForModal"
                                        tooltipClass="custom-revert" *ngIf="demand.demandStatus == 'In Progress'"
                                        placement="bottom" aria-label="Center Align" disabled>
                                        <img src="./../../../assets/images/ic_inProgress.png" height="32" width="32"
                                            class="text-success" alt="" />
                                    </button>
                                    <button [ngbTooltip]="demand.demandStatus" [placement]="tooltipPlacementForModal"
                                        tooltipClass="custom-revert" *ngIf="demand.demandStatus == 'Completed'"
                                        placement="bottom" aria-label="Center Align" disabled>
                                        <img src="./../../../assets/images/Complete.png" height="32" width="32"
                                            class="text-success" alt="" />
                                    </button>
                                </td>
                                <td class="text-center">
                                    <a class="btn btn-ico" *ngIf="demand.customerApprovalComment"
                                        ngbTooltip="{{ 'lblApprovalComment' | translate }}" tooltipClass="custom-revert"
                                        (click)="ViewComment(demand.customerApprovalComment)">
                                        <em class="fas fa-eye fa-lg"></em>
                                    </a>
                                </td>
                                <td class="text-center">
                                    <div class="form-check p-0">
                                        <input type="checkbox" id="Demand{{demand.id}}"
                                            [(ngModel)]="demand.isInWarranty" disabled />
                                    </div>
                                </td>
                                <td class="text-center" style="display: flex;">
                                    <div class='lbl-info' style="width: 140px;">
                                        <ng-select appendTo="body" [clearable]="false" [searchable]="false"
                                            [ngModelOptions]="{standalone: true}" [(ngModel)]="demand.billToCustomer"
                                            disabled>
                                            <ng-option *ngFor="let item of customerList" [value]="item.customerNo">
                                                {{item.customerNo}}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                </td>
                                <td class="text-right"> {{demand.sumPerServiceWithoutDiscountInclVAT| number:'1.2-2'}}
                                </td>
                                <td class="text-right"> {{ demand.fixedPrice | number:'1.2-2' }} </td>
                                <td class="text-right"> {{demand.totalPriceInclVAT| number:'1.2-2'}} </td>
                                <td class="text-right" *ngIf="isShowTax">{{demand.sumPerServiceInclTax |
                                    number:'1.2-2'}}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button class="btn btn-primary customize-btn ml-2"
                [disabled]="isSplitOrderDisabled || !isDemandSelectedToSplit" (click)="splitOrder()"
                aria-label="Center Align">
                <em class="fa fa-minus-circle mr-2"></em><span translate> {{
                    editAppointmentService.appointmentDetails?.appointmentTypeId !== 1 ? 'lblSplitQuote' :
                    'lblSplitOrder' }} </span></button>
            <button class="btn btn-primary customize-btn ml-2"
                [disabled]="(isMakeQuoteFromDemand) && !isDemandSelectedToSplit && editAppointmentService.appointmentDetails?.appointmentTypeId !== 1"
                (click)="createQuoteFromDemand()" aria-label="Center Align">
                <em class="fa fa-minus-circle mr-2"></em><span translate> lblCreateQuote </span></button>
            <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary ml-2" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>